// show-pickup-selector.js
// Busca shows do Metaobject "show" via Storefront API e injeta a propriedade
// de line item correspondente antes do produto ser adicionado ao carrinho.

(function () {
  function initBlock(block) {
    var artista = block.dataset.artista;
    var exclusivo = block.dataset.exclusivo === 'true';
    var shopDomain = block.dataset.shopDomain;
    var token = block.dataset.storefrontToken;

    var loadingEl = block.querySelector('[data-show-pickup-loading]');
    var contentEl = block.querySelector('[data-show-pickup-content]');
    var emptyEl = block.querySelector('[data-show-pickup-empty]');
    var selectEl = block.querySelector('[data-show-pickup-select]');
    var selectWrapper = block.querySelector('[data-show-pickup-select-wrapper]');
    var modeRadios = block.querySelectorAll('input[type="radio"][name^="show-pickup-mode-"]');

    if (!exclusivo) {
      modeRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var selected = block.querySelector('input[name^="show-pickup-mode-"]:checked');
          var isRetirada = selected && selected.value === 'retirada';
          selectWrapper.hidden = !isRetirada;
          if (!isRetirada) {
            selectEl.value = '';
          }
        });
      });
    }

    // Registra o comportamento de submit do carrinho desde já. Se não houver
    // shows disponíveis, o select simplesmente ficará vazio e a propriedade
    // não será adicionada (fallback seguro para entrega normal).
    setupCartIntegration(block, selectEl, selectWrapper, modeRadios, exclusivo);

    if (!token || !shopDomain) {
      console.warn('Show Pickup Block: token ou domínio da loja não configurados.');
      loadingEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }

    // A Storefront API não suporta filtro por valor de campo (isso só existe
    // na Admin API). Por isso buscamos todos os metaobjects do tipo "show"
    // e filtramos por artista/ativo aqui no JavaScript.
    var query = `
      query AllShows {
        metaobjects(type: "show", first: 50) {
          nodes {
            id
            artista: field(key: "artista") { value }
            cidade: field(key: "cidade") { value }
            data: field(key: "data") { value }
            local: field(key: "local") { value }
            horario: field(key: "horario_retirada") { value }
            ativo: field(key: "ativo") { value }
          }
        }
      }
    `;

    fetch('https://' + shopDomain + '/api/2026-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: query })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        loadingEl.hidden = true;

        if (json.errors) {
          console.error('Show Pickup Block - erro GraphQL:', json.errors);
          emptyEl.hidden = false;
          return;
        }

        var allNodes = (json.data && json.data.metaobjects && json.data.metaobjects.nodes) || [];

        // Filtra localmente por artista (case-insensitive) e ativo = true
        var nodes = allNodes.filter(function (node) {
          var nodeArtista = node.artista && node.artista.value ? node.artista.value.toLowerCase() : '';
          var nodeAtivo = node.ativo && node.ativo.value === 'true';
          return nodeArtista === artista.toLowerCase() && nodeAtivo;
        });

        if (nodes.length === 0) {
          emptyEl.hidden = false;
          if (exclusivo) {
            // Produto exclusivo sem show disponível: bloqueia compra visualmente
            block.querySelector('.show-pickup-block__exclusivo-aviso').textContent =
              'Não há shows disponíveis para retirada deste produto no momento.';
          }
          return;
        }

        contentEl.hidden = false;

        nodes.forEach(function (node) {
          var option = document.createElement('option');
          option.value = node.id;
          var cidade = node.cidade ? node.cidade.value : '';
          var data = node.data ? formatDate(node.data.value) : '';
          var local = node.local ? node.local.value : '';
          var horario = node.horario ? node.horario.value : '';

          option.textContent = [cidade, data, local].filter(Boolean).join(' — ');
          option.dataset.cidade = cidade;
          option.dataset.data = data;
          option.dataset.local = local;
          option.dataset.horario = horario;
          selectEl.appendChild(option);
        });
      })
      .catch(function (err) {
        console.error('Show Pickup Block - erro de rede:', err);
        loadingEl.hidden = true;
        emptyEl.hidden = false;
      });
  }

  function formatDate(isoDate) {
    if (!isoDate) return '';
    var parts = isoDate.split('-');
    if (parts.length !== 3) return isoDate;
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  function setupCartIntegration(block, selectEl, selectWrapper, modeRadios, exclusivo) {
    var form = block.closest('form[action*="/cart/add"]');
    var nameInput = block.querySelector('[data-show-pickup-name]');

    if (!form) {
      console.warn('Show Pickup Block: formulário de adicionar ao carrinho não encontrado.');
      return;
    }

    form.addEventListener('submit', function () {
      removeExistingShowInputs(form);

      var wantsRetirada = exclusivo;
      if (!exclusivo) {
        var selected = form.querySelector('input[name^="show-pickup-mode-"]:checked');
        wantsRetirada = selected && selected.value === 'retirada';
      }

      if (!wantsRetirada) return;

      var option = selectEl.options[selectEl.selectedIndex];
      if (!option || !option.value) return;

      addHiddenInput(form, 'properties[_show_id]', option.value);
      addHiddenInput(form, 'properties[Show]', option.dataset.cidade + ' — ' + option.dataset.data);
      addHiddenInput(form, 'properties[Local]', option.dataset.local);
      addHiddenInput(form, 'properties[Horário de retirada]', option.dataset.horario);

      var nomeRetirada = nameInput && nameInput.value.trim();
      if (nomeRetirada) {
        addHiddenInput(form, 'properties[Quem vai retirar]', nomeRetirada);
      }
    });
  }

  function addHiddenInput(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value || '';
    input.dataset.showPickupInjected = 'true';
    form.appendChild(input);
  }

  function removeExistingShowInputs(form) {
    form.querySelectorAll('[data-show-pickup-injected]').forEach(function (el) {
      el.remove();
    });
  }

  document.querySelectorAll('[data-show-pickup-block]').forEach(initBlock);
})();